import React from 'react';
import UserAccount from './UserAccount';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import Formulario from 'components/formulario';
import Alert from 'react-s-alert';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';

const FormElements= (props)=> {
    let history = useHistory();
    const [userAccount,] = React.useState(new UserAccount());
    const [apiErrors,setApiErrors] = React.useState([]);
    const [elements,] = React.useState({
        email:{
            idelement: "email", value:'', label: "Correo electrónico", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', width: '90%', marginTop: '0%'
        },
        password:{
            idelement: "password", value:'', label: "Contraseña", pattern:"^[\\w_\\sÑñáéíóúÁÉÍÓÚ().!@#$%^&*/-]{6,20}$", validators: ['required'], errorMessages:['Alfanumérico y simbolos "().%$#/-@" de 6 a 20 caracteres'], isError:false, elementType:'password', width: '90%', marginTop: '5%'
        },
    });

    const loginError=()=>{

        buttonList["register"].loading=false;
        let errors=  userAccount.getErrors();

        if (errors!==undefined){
            let newApiErrors=[];
            errors.forEach((item)=>{
                newApiErrors.push({"attribute":item.field,"message":item.defaultMessage});
            });
            setApiErrors(newApiErrors);
        }else if (userAccount.getErrorMessage()==="Bad credentials") alertaPersonalizadaSwal("Credenciales incorrectas", "", 'error', true);
        else if (userAccount.getErrorMessage()==="Failed to fetch") alertaPersonalizadaSwal("Intente de nuevo", "", 'error', true);
        else if (userAccount.getErrorMessage()==="Internal Server Error") alertaPersonalizadaSwal("Error de servidor", "", 'error', true);
        else alertaPersonalizadaSwal(userAccount.getErrorMessage(), "", 'error', true);

        var clonedButtonList = Object.assign({}, buttonList);
        setButtonList(clonedButtonList);
    }

    const loginSuccess=async ()=>{
        props.SET_MENU(userAccount.getMenu());
        props.SET_CURRENT_USER(userAccount.getCurrentUser());
        history.push("/",{});
    }

    const login=async (data, _)=>{
        var clonedButtonList = Object.assign({}, buttonList);
        buttonList["register"].loading=true;
        setButtonList(clonedButtonList);

        userAccount.setEmail(data.email);
        userAccount.setPassword(data.password);
        await userAccount.login();
        if (userAccount.getIsError()) loginError();
        else loginSuccess();
    }

    const [buttonList,setButtonList]= React.useState({
        "register":{"label":"Iniciar sesión","callback":login,"loading":false,"size":"medium","color":"#fff", "icon":"login","background":"linear-gradient(130deg, rgb(18 176 234) 30%, #3f51b5 90%) 0% 0% repeat scroll", width: '87%'},
    });

    return (
        <Formulario
            elements= {elements}
            buttonList={buttonList}
            apiErrors={apiErrors}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(FormElements);